import { MenuItem } from "@app/types";
import { MenuLabel, RoutePath } from "./common.const";
import NotebookIcon from "@app/icons/notebook";
import UserIcon from "@app/icons/user";
import TransactionIcon from "@app/icons/transaction";
import WalletIcon from "@app/icons/wallet";
import RulesIcon from "@app/icons/rules";
import ShieldIcon from "@app/icons/shield";
import SupportIcon from "@app/icons/support";
import NoteIcon from "@app/icons/note";
import AffiliateIcon from "@app/icons/affiliate";

export const UserMenuList: readonly MenuItem[] = [
  {
    linkTo: RoutePath.USER_ACCOUNT,
    icon: <UserIcon />,
    label: MenuLabel.USER_ACCOUNT,
  },
  {
    linkTo: RoutePath.USER_LIBRARY,
    icon: <NotebookIcon />,
    label: MenuLabel.USER_LIBRARY,
  },
  {
    linkTo: RoutePath.USER_WALLET,
    icon: <WalletIcon />,
    label: MenuLabel.USER_WALLET,
  },
  {
    linkTo: RoutePath.USER_AFFILIATE,
    icon: <AffiliateIcon />,
    label: MenuLabel.USER_AFFILIATE,
  },
  {
    linkTo: RoutePath.USER_TRANSACTION,
    icon: <TransactionIcon />,
    label: MenuLabel.USER_TRANSACTION,
  },
  {
    linkTo: RoutePath.REFERRER,
    icon: <NoteIcon />,
    label: MenuLabel.REFERRER,
  },
  {
    linkTo: RoutePath.USER_RULES,
    icon: <RulesIcon />,
    label: MenuLabel.USER_RULES,
    linkOther: "https://bookas.vn/rules",
  },
  {
    linkTo: RoutePath.USER_POLICIES,
    icon: <ShieldIcon />,
    label: MenuLabel.USER_POLICIES,
    linkOther: "https://bookas.vn/policies",
  },
  {
    linkTo: RoutePath.USER_SUPPORT,
    icon: <SupportIcon />,
    label: MenuLabel.USER_SUPPORT,
    linkOther: "https://bookas.vn/faqs",
  },
];
